export const pxToRem = (px: number) => px / 16;

export const remToPx = (rem: number) => rem * 16;

/**
 * Converts CSS values to numeric values.
 *
 * @param cssValue - CSS value string (e.g., '16px', '1rem', '16', 16) or undefined
 * @returns Numeric value in pixels, or 0 if cssValue is undefined
 *
 * @example
 * ```typescript
 * getNumericValue('16px') // returns 16
 * getNumericValue('1rem') // returns 16 (assuming 16px base font size)
 * getNumericValue('16') // returns 16
 * getNumericValue(16) // returns 16
 * getNumericValue(undefined) // returns 0
 * ```
 */
export const getNumericValue = (cssValue?: string | number): number => {
  if (typeof cssValue === 'number') {
    return cssValue;
  }

  if (!cssValue) {
    return 0;
  }

  if (cssValue.endsWith('rem')) {
    return remToPx(parseFloat(cssValue.substring(0, cssValue.length - 3)));
  } else if (cssValue.endsWith('px')) {
    return parseFloat(cssValue.substring(0, cssValue.length - 2));
  }

  return parseFloat(cssValue);
};
